<template>
  <div class="container" style="padding: 30px; margin-top: 50px">
    <div class="col-md-12 mb-3 mt-3" style="margin: 15px">
      <div class="full-center">
        <div class="card generator-card">
          <div class="card-body">

            <div class="form-vertical">

              <div class="form-row">
                <label class="form-label">หมายเลขสุ่ม:</label>
                <input v-model.number="data.random_number" type="number" min="1" class="form-control generator-input"
                  placeholder="เช่น 1234" />
              </div>

              <div class="form-row">
                <label class="form-label">ชื่อ:</label>
                <input v-model="data.firstname" type="text" class="form-control generator-input" />
              </div>

              <div class="form-row">
                <label class="form-label">นามสกุล:</label>
                <input v-model="data.lastname" type="text" class="form-control generator-input" />
              </div>

              <div class="form-row">
                <label class="form-label">เบอร์โทรศัพท์:</label>
                <input v-model="data.phone" type="number" class="form-control generator-input" max="10"/>
              </div>

              <div class="text-end mt-3">
                <button type="button" class="btn btn-success btn-lg generator-btn" @click="register">
                  คลิก
                </button>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import MonitoringNumberService from "../services/MonitoringNumberService";
import ParticipantService from "../services/ParticipantService";

export default {
  name: "Nav",
  components: {
  },
  props: {
    msg: String,
  },
  data() {
    return {
      data: {}
    };
  },
  mounted() {
    const key = "device_id";
    let id = localStorage.getItem(key);
    console.log(id);
  },
  methods: {
    register() { 
      if (this.data.random_number == '' || this.data.random_number == null) {
        alert('กรุณากรอกหมายเลขสุ่ม');
        return;
      }else if (this.data.firstname == '' || this.data.firstname == null) {
        alert('กรุณากรอกชื่อ');
        return;
      }else if (this.data.lastname == '' || this.data.lastname == null) {
        alert('กรุณากรอกนามสกุล');
        return;
      }else if (this.data.phone == '' || this.data.phone == null) {
        alert('กรุณากรอกเบอร์โทรศัพท์');
        return;
      }
      MonitoringNumberService.get_monitoring_number(this.data.random_number).then(
        (response) => {
          // console.log(response);
          if (response.status == 200) {
            if (response.data.length == 0) {
              alert('ไม่พบหมายเลขสุ่มนี้ในระบบ กรุณาตรวจสอบหมายเลขสุ่มอีกครั้ง');
              return;
              
            }
            this.data.monitoring_number_id = response.data.id
            if (response.data.active == true) {
              ParticipantService.get_participant_by_monitoring(this.data.monitoring_number_id).then(
                (response) => {
                  // console.log(response);
                  if (response.data.firstname == this.data.firstname && response.data.lastname == this.data.lastname) {
                    const key = "device_id";
                    localStorage.setItem(key, response.data.imei);
                    localStorage.setItem("participant_id", response.data.id);
                    this.$router.push("/home");
                    return;
                  } else {
                    alert('หมายเลขสุ่มนี้ถูกใช้งานแล้ว กรุณาตรวจสอบหมายเลข ชื่อ หรือนามสกุลสุ่มอีกครั้ง');
                    return;
                  }
                },
                (error) => {
                  console.log(error);
                }
              );
            }else{
            this.data.device_id = this.getDeviceId();
            var registered = {
              monitoring_number_id: this.data.monitoring_number_id,
              imei: this.data.device_id,
              firstname: this.data.firstname,
              lastname: this.data.lastname,
              phone: this.data.phone
            }
            ParticipantService.create_participants(registered).then(
              (response) => {
                if (response.status == 200) {
                  var update = {
                    active: true,
                    updated_by: response.data.id,
                  }
                  // console.log(this.data.monitoring_number_id,update);
                  
                  MonitoringNumberService.updatemonitoring_number(this.data.monitoring_number_id,update).then(
                    () => {
                      // console.log(response);
                      this.$router.push("/home");
                    },
                    (error) => {
                      console.log(error);
                    }
                  );
                } else {
                  alert(response.data.message);
                }
              },
              (error) => {
                console.log(error);
              }
            );
            }
          } else {
            alert('ไม่พบหมายเลขสุ่มนี้ในระบบ กรุณาตรวจสอบหมายเลขสุ่มอีกครั้ง');
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
    getDeviceId() {
      const key = "device_id";
      let id = localStorage.getItem(key);
      if (!id) {
        id = crypto.randomUUID();
        localStorage.setItem(key, id);
      }
      return id;
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
};
</script>

<style scoped>
.form-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.form-row label {
  width: 150px;
  margin-bottom: 0;
  font-weight: 500;
}

.form-row input {
  flex: 1;
}

.generator-btn {
  margin-top: 10px;
}
</style>
